<template>
  <div class="iframe-shell" :style="{ height: `${height}px` }">
    <!-- Overlay se spinnerem -->
    <transition name="fade">
      <div v-if="!loaded" class="loader-overlay">
        <v-progress-circular indeterminate size="40" />
      </div>
    </transition>

    <iframe
      ref="iframeRef"
      :id="iframeId"
      :src="embedUrl"
      style="width: 100%; border: 0; height: 100%;"
      scrolling="no"
      frameborder="0"
      allow="autoplay; fullscreen; picture-in-picture"
      allowfullscreen
      @load="onLoad"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount, computed, watch } from 'vue'

const props = defineProps<{
  embedUrl?: string
  gameSlug?: string
  gameId?: string
  initialHeight?: number
}>()

const SPORT_VIDEO_ORIGIN = 'https://sport.video'
const height = ref(props.initialHeight ?? 600)
const loaded = ref(false)
const iframeRef = ref<HTMLIFrameElement | null>(null)
const iframeId = computed(() => `svIframe-${(props.gameSlug || 'game').replace(/[^a-z0-9-]/gi,'')}`)

const embedUrl = computed(() => {
  if (props.embedUrl) return props.embedUrl
  if (props.gameSlug && props.gameId)
    return `${SPORT_VIDEO_ORIGIN}/embed-game/${props.gameSlug}/${props.gameId}`
  return ''
})

// Když se změní URL, ukaž znovu loader
watch(embedUrl, () => { loaded.value = false })

function onMessage(ev: MessageEvent) {
  if (ev.origin !== SPORT_VIDEO_ORIGIN) return
  if (typeof ev.data === 'number' && ev.data > 0) {
    height.value = ev.data
  }
}

function onLoad() {
  // Pošli ping do iframu pro výšku a skryj loader
  try {
    iframeRef.value?.contentWindow?.postMessage('message', SPORT_VIDEO_ORIGIN)
  } catch {}
  loaded.value = true
}

onMounted(() => {
  window.addEventListener('message', onMessage, false)
})

onBeforeUnmount(() => {
  window.removeEventListener('message', onMessage, false)
})
</script>

<style scoped>
.iframe-shell {
  position: relative;
  width: 100%;
  background: #000; /* příjemný backgroud než se načte video */
  border-radius: 0px;
  overflow: hidden;
}

/* Overlay */
.loader-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: none;
  /* volitelně přitmavení: */
  background: rgba(0, 0, 0, 0.3);
  z-index: 1;
}

/* Jemné zmizení */
.fade-enter-active,
.fade-leave-active {
  transition: opacity .2s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

</style>
